import React, { useEffect } from 'react';
import { Route, Switch, Redirect, useHistory, useParams } from 'react-router-dom';
import { getFromStore, saveToStore } from 'utils/storeHelpers';
import { Auth } from 'aws-amplify';
import Header from 'shared/components/layout/Header';
import Home from './routes/Home';
import Friends from './routes/Friends';
import Products from './routes/Products';
import ProductView from './routes/ProductView';
import Polls from './routes/Polls';
import NotFound from 'shared/components/pages/NotFound';
import Search from './routes/Search';
import PollView from './routes/PollView';
import Account from './routes/Account';
import UserView from './routes/UserView';
import UserProjects from './routes/UserProjects';
import UserProduct from './routes/UserProduct';
import CategoriesProducts from './routes/CategoriesProducts';
import Footer from '../Landing/components/Footer';
import VerifyEmail from './routes/VerifyEmail';
import ReminderExtModal from 'shared/components/modals/ReminderExtModal';
import { confirmAlert } from 'react-confirm-alert';
import { isIOS } from 'shared/utils/appHelpers';
import ReminderMobileModal from 'shared/components/modals/ReminderMobileModal';
import ComparisonHistory from '../ComparisonHistory';

const Dashboard = ({ match }) => {
  const history = useHistory();
  const { lang } = useParams(); // Get language from URL params
  const fromLogin = history.location.pathname.includes('/auth/');
  const basePath = lang ? `/${lang}` : ''; // Base path with language prefix if present

  const showAppsReminders = () => {
    const showLikieeOnBoarding = !getFromStore('onboarding_likiee_project');
    const showCategoryOnBoarding = !getFromStore('onboarding_likiee_category');
    if (showLikieeOnBoarding || showCategoryOnBoarding) return;

    const isExtReminderShowed = getFromStore('extension_reminder');
    const extExist = getFromStore('ext_exist');

    const isMobileReminderShowed = getFromStore('mobile_reminder');
    const isIosDevice = isIOS();

    if (!isMobileReminderShowed && isIosDevice) {
      confirmAlert({
        overlayClassName: 'reminder-overlay',
        closeOnClickOutside: false,
        customUI: ({ onClose }) => <ReminderMobileModal onClose={onClose} />,
      });
      return;
    }

    if (!isExtReminderShowed && !extExist) {
      confirmAlert({
        overlayClassName: 'reminder-overlay',
        closeOnClickOutside: false,
        customUI: ({ onClose }) => <ReminderExtModal onClose={onClose} />,
      });
    }
  };

  const saveExtensionLoginData = async () => {
    const session = await Auth.currentSession();
    const saveData = {
      idToken: session.idToken.jwtToken,
      refreshToken: session.refreshToken.token,
      exp: session.idToken.payload.exp,
      clientID: session.idToken.payload.aud,
    };
    saveToStore('auth_ext', JSON.stringify(saveData));
  };

  useEffect(() => {
    if (fromLogin) history.push(`${basePath}/dashboard`);
    showAppsReminders();
    saveExtensionLoginData();
  }, []);

  return (
    <div className='dashboard pt-32 pt-md-0 d-flex flex-column justify-content-between min-vh-100'>
      <Header />
      <div className='dash-content container mt-8 mt-md-15 d-flex flex-column flex-fill'>
        <Switch>
          <Route path={`${basePath}/verify`} component={VerifyEmail} />
          <Route path={`${basePath}/404`} component={NotFound} />
          <Route path={`${basePath}/search`} component={Search} />
          <Route path={`${basePath}/friends`} component={Friends} />
          <Route path={`${basePath}/polls`} component={Polls} />
          <Route path={`${basePath}/poll/:id`} component={PollView} />
          <Route path={`${basePath}/profile`} component={Account} />
          <Route path={`${basePath}/likiees/category/:id/:name`} component={CategoriesProducts} />
          <Route path={`${basePath}/likiees/:type/:id?`} component={Products} />
          <Route path={`${basePath}/likiee/:id`} component={ProductView} />
          <Route path={`${basePath}/comparison-history`} component={ComparisonHistory} />
          <Route path={`${basePath}/user/:id/project/:projectId/p/:productId`} component={UserProduct} />
          <Route path={`${basePath}/user/:id/project/:projectId`} component={UserProjects} />
          <Route path={`${basePath}/user/:id`} component={UserView} />
          <Route exact path={`${basePath}/dashboard`} component={Home} />
          <Route exact path={basePath || '/'} component={Home} />
          <Redirect from='*' to={`${basePath}/404`} />
        </Switch>
      </div>
      <Footer className='border-top' />
    </div>
  );
};

export default Dashboard;
